var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAtherGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 113 113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_82",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 82",
    x1: 48.41,
    y1: 7.19,
    x2: 63.93,
    y2: 83.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f6f8fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m36.45,97.66c-2.89-2.36-6.33-3.87-9.96-4.73-9.35-2.2-16.32-10.61-16.32-20.61V22C10.16,10.3,19.64.82,31.34.82h50.33c11.69,0,21.17,9.48,21.17,21.17v50.33c0,10.01-6.98,18.41-16.32,20.61-3.63.85-7.07,2.37-9.96,4.73l-16.09,13.11c-2.31,1.88-5.61,1.88-7.92,0l-16.09-13.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.51,10.2h50.15c6.51,0,11.8,5.29,11.8,11.8v50.33c0,6.51-5.29,11.8-11.8,11.8H31.34c-6.51,0-11.8-5.29-11.8-11.8V22.17c0-6.61,5.37-11.97,11.97-11.97Z",
    fill: "url(#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_82)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m88,47.14c.05,17.14-13.97,31.57-31.67,31.48-17.33-.08-31.46-14.23-31.33-31.71.13-17.1,14.04-31.2,31.51-31.2,17.55,0,31.52,14.33,31.49,31.43Zm-58.15-.12c.03,14.65,11.79,26.39,26.17,26.62,15.1.25,26.98-11.9,27.12-26.3.15-14.83-11.82-26.84-26.48-26.9-14.8-.07-26.81,11.88-26.82,26.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.65,53.71c0,2.12-1.41,4.02-3.42,4.64-2.07.64-4.35-.13-5.51-1.93-.55-.85-.98-1.79-1.45-2.7-1.92-3.75-3.83-7.51-5.75-11.27-.49-.96-.98-1.92-1.46-2.88-1.15-2.31-.27-5.09,2.01-6.42,2.18-1.26,5.09-.58,6.48,1.59.51.79.9,1.66,1.33,2.5,1.4,2.74,2.79,5.48,4.19,8.22,1.02,2,2.04,3.99,3.05,5.99.36.71.54,1.46.52,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.91,52.82c0,3.19-2.6,5.75-5.82,5.75-3.16,0-5.76-2.61-5.75-5.79,0-3.17,2.63-5.76,5.83-5.76,3.16,0,5.75,2.62,5.75,5.8Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 13,
    r: 10,
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 13,
    r: 7,
    fill: "#6dea00"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtherGreen);
export default __webpack_public_path__ + "static/media/Ather_green.1ccb2562b622c5f0919ea5197e8e27bb.svg";
export { ForwardRef as ReactComponent };